/*global $$re */
import defineFilters from './filters'
import defineListeners from './listeners'

const listeners = function () {
  const {EventBus, DataFilter} = this
  // define listeners
  defineListeners(EventBus)
  defineFilters(DataFilter)
}

$$re('beforeReady', listeners)

